import gql from 'graphql-tag';

export const ATTACH_TO_CONTAINER = gql`
  mutation($containerId: Int!, $styleId: Int!) {
    cssStyle {
      attachStyleToContainer(containerId: $containerId, styleId: $styleId)
    }
  }
`;
